import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-transcode",
  "use": "icon-transcode-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-transcode\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M20,21a12.08,12.08,0,0,1-8,3h0A12,12,0,0,1,0,12.09,11.77,11.77,0,0,1,2.17,5.26l.73-1L7,12.87H3.8a8.1,8.1,0,0,0,5.11,6.74A8.33,8.33,0,0,0,18,17.75M6,6.25a8.34,8.34,0,0,1,9.07-1.86,8.1,8.1,0,0,1,5.11,6.74H17l4.14,8.64.73-1A11.82,11.82,0,0,0,24,11.91,12,12,0,0,0,12,0h0A12.08,12.08,0,0,0,4,3\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol